module.exports = __webpack_public_path__ + "img/fim.7a6e2686.svg";